import React from "react";
import toast from "react-hot-toast";
import withProviders from "../../../hooks/withProviders";
import { oidcClient } from "../../../redux/token";
import { GenericLayoutPageSubHeader, Main } from "../../../components/utilities";
import { MicroserviceManagementProvider, MicroserviceActionsDropdown, MicroserviceActionsDropdownItem, MicroserviceStatusDisplay } from "../../../features/microservicemanagement";
import { MicroserviceEventsTable } from "../../../features/microserviceeventstable";
import { useLazyFetchClientDetailsMicroserviceEventsQuery } from "../../../services/clientdetails";

export const ClientDetailsMicroserviceManagementPage = withProviders([
    MicroserviceManagementProvider, {
        healthEndpoint: '/api/clientdetails/health',
        seedEndpoint: '/api/clientdetails/system/seed'
    }
])(({ initiateEndpoint = "/api/clientdetails/system/initiate-primary-delegate-owners" }: Readonly<{ initiateEndpoint?: string }>) => {

    const executeInitiateDesignationOwners = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(initiateEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Initiate Primary Designation Owners Job has started.'))
            .catch(() => toast.error('Failed to start the initiate primary designation owners Job.'));
    };

    return (
        <Main className="d-flex flex-column">
            <GenericLayoutPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <MicroserviceStatusDisplay/>
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center">
                        <MicroserviceActionsDropdown>
                            <MicroserviceActionsDropdownItem icon={['fas', 'user-tag']} onClick={executeInitiateDesignationOwners} text="Initiate Primary Designation Owners" />
                        </MicroserviceActionsDropdown>
                    </div>
                </div>
            </GenericLayoutPageSubHeader>
            <section className="px-4 my-3 h-100">
                <MicroserviceEventsTable query={useLazyFetchClientDetailsMicroserviceEventsQuery}/>
            </section>
        </Main>
    )
})